import Pill from "./pill"

export default function PillList({ items = [], className }) {
  if (!items.length) return null
  return (
    <div
      className={className}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        alignContent: "flex-start",
        flexWrap: "wrap",
        gap: "4px",
        alignSelf: "stretch",
      }}
    >
      {items.map((item) => (
        <Pill key={item}>{item}</Pill>
      ))}
    </div>
  )
}
